import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
//components
import Modal from "../../../../../../../components/modal/Modal";
import Select from "../../../../../../../components/input/Select";
import NumberInput from "../../../../../../../components/input/NumberInput";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
//services
import { getCession } from "../../../../../../../services/Contracts/getCession";
import { putCession } from "../../../../../../../services/Contracts/putCession";
import { postCession } from "../../../../../../../services/Contracts/postCession";
//utils
import { formatDate } from "../../../../../../../utils/formatDate";
import { queryClient } from "../../../../../../../utils/queryClient";
import { formatCurrency } from "../../../../../../../utils/formatCurrency";
//hooks
import { useOptionsSelect } from "../../../../../../../hooks/useOptionsSelect";
import { useAppContext } from "../../../../../../../context/AppContext";

const Assignment = ({
  setActiveIndex,
  id,
  cliData,
  setModalActionsActive,
  setDefaultIndexColorActive,
  setTypeActionContract,
  setIdAssignment,
}) => {
  const form = useForm();
  const errors = form.formState.errors;
  const { permissions } = useAppContext();

  const [tableData, setTableData] = useState([]);
  const [tableDataModal, setTableDataModal] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [clientsCession, setClientsCession] = useState([{ owner: true }]);
  const [cessionValue, setCessionValue] = useState(0);
  const [newOwner, setNewOwner] = useState();
  const [successPost, setSuccessPost] = useState(false);
  const [totalPercentage, setTotalPercentage] = useState(0);
  const columns = [
    { field: "old_client_name", header: "Cedente" },
    { field: "new_cliente_name", header: "Cessionário" },
    { field: "due_date", header: "Data" },
    { field: "value_cession", header: "Valor" },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "Em Análise";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Aprovada";
            break;
          case 2:
            labelClass = "badge bg-danger";
            labelText = "Recusada";
            break;
          default:
        }

        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginLeft: "15px",
              marginRight: "-40px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
  ];
  const columnsModal = [
    { field: "old_client_name", header: "Cedente" },
    { field: "new_cliente_name", header: "Cessionário" },
    { field: "porcentagens", header: "Porcentagem" },
    { field: "value_cession", header: "Valor" },
    { field: "made_by", header: "Feito Por" },
    { field: "due_date", header: "Data" },
  ];

  const { client, isLoadingClients } = useOptionsSelect();

  const {
    data: assignments,
    isLoading: isLoadingAssignments,
    refetch,
  } = useQuery({
    queryKey: [`cession${id}`],
    queryFn: () => getCession(id),
    enabled: !!permissions?.includes("55"),
  });

  const { mutateAsync: postCessionFn } = useMutation({
    mutationFn: postCession,
    onSuccess(data, variables) {
      refetch();
      setSuccessPost(!successPost);
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const { mutateAsync: putCessionFn } = useMutation({
    mutationFn: putCession,
    onSuccess(_, variables) {
      queryClient.setQueryData([`cession${id}`], (data) => {
        const updatedData = [...data];
        const index = updatedData.findIndex(
          (i) => i.id === tableDataModal[0].id
        );
        if (index !== -1) {
          updatedData[index].status = variables.action ? 2 : 1;
          setNewOwner(updatedData[index].new_cliente);
        }
        refetch();
        setSuccessPost(!successPost);
        return updatedData;
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const onSubmit = async (data) => {
    data = {
      sale_id: id,
      value_cession: cessionValue,
      clients: clientsCession.map((client) => ({
        id: client.id,
        owner: client.owner || false,
        percentage: client.percentage,
      })),
    };

    console.log(data);
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await postCessionFn(data);
      toast.update(notification, {
        render: "Cessão enviada para análise!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
      setCessionValue(0);
      form.reset();
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      form.reset();
      return;
    }
  };

  useEffect(() => {
    console.log(assignments, client);
    if (assignments && client) {
      const infoPercentage = assignments.map((item) => {
        console.log(item);
        const oldClientMatch = client.find(
          (client) => client.value === item.old_cliente
        );
        const NewclientMatch = client.find(
          (client) => client.value === item.new_cliente
        );

        // Verifica se há landOwners e formata os nomes e porcentagens
        const cessionarios = item.landOwners
          ? item.landOwners.map((owner) => owner.client.name).join(" | ")
          : item.assignee?.name || "-";
        const cedentes = Array.isArray(item.assignor)
          ? item.assignor.map((assignor) => assignor.name).join(" | ")
          : item.assignor?.name || "-";

        const porcentagens = item.landOwners
          ? item.landOwners.map((owner) => `${owner.percentage}%`).join(" | ")
          : "-";

        if (item && item.total_cession !== null) {
          return {
            ...item,
            total_cession: `${item.total_cession}%`,
            old_client_name: cedentes ? cedentes : "-",
            new_cliente_name: cessionarios ? cessionarios : "-",
            cessionarios, // Novo campo com os nomes dos cessionários
            porcentagens, // Novo campo com as porcentagens
            due_date: formatDate(item.created_at),
            value_cession: formatCurrency(item.value_cession),
            made_by: item?.user?.name,
          };
        }
        return item;
      });

      console.log(infoPercentage);

      setTableData(infoPercentage);
    }
  }, [assignments, client, successPost]);

  useEffect(() => {
    const total = testPercentage();
    setTotalPercentage(total);
  }, [clientsCession]);

  const testPercentage = () => {
    let total = 0;
    clientsCession.map((c) => {
      if (c.percentage) {
        total += c.percentage;
      }
      return total;
    });
    return total;
  };

  const handleReview = (e, data) => {
    console.log(data);
    e.preventDefault();
    setTableDataModal([data]);
    setShowModal(true);
  };

  const handleAccept = async () => {
    const data = {
      sale_id: id,
      action: true,
    };
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await putCessionFn(data);
      toast.update(notification, {
        render: "Cessão Aprovada com Sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    }
    setShowModal(false);
  };

  const handleDeny = async () => {
    const data = {
      sale_id: id,
      action: false,
    };
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await putCessionFn(data);
      toast.update(notification, {
        render: "Cessão Recusada com Sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    }
    setShowModal(false);
  };

  const handleAddClients = () => {
    setClientsCession((prev) => [...prev, { id: null, percentage: 0 }]);
  };

  const handleRemoveClients = (e, index) => {
    e.preventDefault();
    form.setValue(`id_client[${index}]`, "");
    form.setValue(`percentage[${index}]`, "");
    const updatedClients = [...clientsCession];
    updatedClients.splice(index, 1);
    setClientsCession(updatedClients);
  };

  const handleSelectChange = (e, index) => {
    const newClientsCession = [...clientsCession];
    newClientsCession[index] = {
      ...newClientsCession[index],
      id: e,
    };
    setClientsCession(newClientsCession);
  };

  const handleInputChange = (e, index) => {
    let newValue = e.value;
    console.log(newValue);
    if (newValue >= 100) {
      newValue = 100;
    }
    console.log(newValue);
    const newClientsCession = [...clientsCession];
    newClientsCession[index] = {
      ...newClientsCession[index],
      percentage: newValue,
    };
    setClientsCession(newClientsCession);
  };

  const newClientName = (id) => {
    const newclientMatch = client.find((client) => client.value === id);
    return newclientMatch.label;
  };

  return (
    <>
      <div>
        <div className="row">
          <div className="card-border me-2 my-2">
            <div className="title-container">
              <p>
                {" "}
                <i className="fa-solid fa-arrow-right-arrow-left me-2"></i>
                Cessão e Transferência de Direitos e Obrigações
              </p>
            </div>
            <div className="row mt-2 p-4">
              <h4 className="text-success">
                <i className="fa-regular fa-address-card mx-2"></i>Identificação
              </h4>
              <hr />
              <div className="row d-flex">
                <p>
                  Cedente Titular:{" "}
                  <b className="text-capitalize">
                    {newOwner
                      ? newClientName(newOwner)
                      : cliData?.assignee?.name}
                  </b>
                </p>
              </div>
              <form onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
                <div className="row">
                  <div className="col-xl-3 col-md-6">
                    <label htmlFor="entrada">Valor da Cessão</label>
                    <InputNumber
                      disabled={permissions && !permissions.includes("67")} //Cadastrar Cessão
                      name="value_cession"
                      value={cessionValue}
                      onChange={(e) => setCessionValue(e.value)}
                      mode="currency"
                      currency="BRL"
                      locale="pt-BR"
                      className="input"
                      min={0}
                    />
                  </div>
                </div>
                <div className="row">
                  {clientsCession.map((cli, index) => (
                    <div
                      className={`row col-xl-9 col-md-12 ${
                        window.innerWidth <= 992 ? "" : "d-flex"
                      }`}
                      key={index}
                    >
                      <div className="col-xl-5 col-md-5 mb-1">
                        <Select
                          name={`id_client[${index}]`}
                          label={
                            isLoadingClients ? "Carregando..." : "Cessionário"
                          }
                          errors={errors}
                          disabled={
                            isLoadingClients &&
                            permissions &&
                            !permissions.includes("67")
                          } //Cadastrar Cessão
                          isRequired={true}
                          onChange={(e) => handleSelectChange(e, index)}
                          control={form.control}
                          options={client.map((c) => ({
                            ...c,
                            disabled: clientsCession.some(
                              (cli) =>
                                cli.id === c.value &&
                                clientsCession[index].id !== c.value
                            ),
                          }))}
                        />
                      </div>
                      <div
                        className={`col-xl-3 col-md-4 ${
                          window.innerWidth <= 992 ? "" : "ms-4 mb-1"
                        }`}
                      >
                        <NumberInput
                          disabled={permissions && !permissions.includes("67")} //Cadastrar Cessão
                          name={`percentage[${index}]`}
                          suffix="%"
                          placeholder="0%"
                          max={100}
                          min={0}
                          errors={errors}
                          required={true}
                          tooltip={
                            index === 0 &&
                            totalPercentage != 100 &&
                            "O total precisa ser 100%"
                          }
                          tooltipOptions={{ position: "top" }}
                          minFractionDigits={2}
                          maxFractionDigits={2}
                          control={form.control}
                          onChange={(e) => handleInputChange(e, index)}
                          label={index === 0 ? "% Titular" : `% Proprietário`}
                        />
                      </div>
                      {totalPercentage < 100 && (
                        <div className="col-xl-2 col-md-3 pt-4">
                          {index > 0 && (
                            <Button
                              rounded
                              outlined
                              severity="danger"
                              icon="fa fa-minus"
                              className="mx-1 mt-1"
                              onClick={(e) => handleRemoveClients(e, index)}
                              style={{
                                width: "2rem",
                                height: "2rem",
                                padding: "2px",
                              }}
                            />
                          )}
                          {index === clientsCession.length - 1 &&
                            permissions &&
                            permissions.includes("67") && (
                              <Button
                                rounded
                                outlined
                                size="small"
                                severity="success"
                                icon="fa fa-plus"
                                onClick={handleAddClients}
                                className="mx-2 mt-1 pt-1"
                                style={{
                                  width: "2rem",
                                  height: "2rem",
                                  padding: "2px",
                                }}
                              />
                            )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {permissions &&
                  permissions.includes("67") && ( //Confirmar Cessão
                    <div className="col-md-12 text-end mb-2">
                      <Button
                        rounded
                        type="submit"
                        disabled={totalPercentage !== 100}
                        label={`Confirmar`}
                        loading={loadingButton}
                        icon="fa fa-circle-check"
                        className="p-inputtext-sm mt-4 me-2 m-auto w-80"
                      />
                    </div>
                  )}
              </form>
              <div className="row mt-2">
                <h4 className="text-success">
                  <i className="fa-solid fa-clock-rotate-left mx-2"></i>
                  Histórico de Cessão
                </h4>
                <hr></hr>
                {isLoadingAssignments || isLoadingClients ? (
                  <Skeleton width="100%" height="300px" />
                ) : (
                  <DataTable
                    rows={5}
                    paginator
                    stripedRows
                    showGridlines
                    sortMode="multiple"
                    selectionMode="single"
                    // loading={isLoadingAssignments && isLoadingClients}
                    rowsPerPageOptions={[5, 25, 100]}
                    value={tableData}
                    emptyMessage="Nenhuma Informação foi encontrada."
                    tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                  >
                    {columns.map((col) => (
                      <Column
                        sortable
                        key={col.field}
                        body={col.body}
                        field={col.field}
                        header={col.header}
                      />
                    ))}
                    <Column
                      header="Ações"
                      body={(rowData) =>
                        rowData.status === 0 &&
                        permissions &&
                        permissions.includes("55") ? ( //Visualizar Cessão
                          <div className="text-center">
                            <button
                              className="btn btn-success btn-btn-sm"
                              onClick={(e) => handleReview(e, rowData)}
                            >
                              <i className="fa-solid fa-check"></i>
                            </button>
                          </div>
                        ) : rowData.status === 2 ? (
                          <div className="text-center">
                            <button
                              className="btn btn-info btn-btn-sm"
                              onClick={(e) => {
                                setIdAssignment(rowData.id);
                                setTypeActionContract("cessao");
                                setModalActionsActive(true);
                                setDefaultIndexColorActive(1);
                              }}
                            >
                              <i className="fa fa-print"></i>
                            </button>
                          </div>
                        ) : (
                          <></>
                        )
                      }
                    />
                  </DataTable>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        visible={showModal}
        position="center"
        onHide={() => setShowModal(false)}
        dynamicTitle="Resumo da Cessão"
      >
        <DataTable
          rows={5}
          stripedRows
          showGridlines
          sortMode="multiple"
          selectionMode="single"
          // loading={isLoadingAssignments && isLoadingClients}
          value={tableDataModal}
          emptyMessage="Nenhuma Informação foi encontrada."
          tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
        >
          {columnsModal.map((col) => (
            <Column
              sortable
              key={col.field}
              body={col.body}
              field={col.field}
              header={col.header}
            />
          ))}
        </DataTable>

        <div className="row mt-4 justify-content-center">
          {permissions &&
            permissions.includes("68") && ( //Aprovar Cessão
              <div className="col-md-6 text-center">
                <Button
                  label="Aprovar"
                  className="bg-success w-50"
                  icon="fa-solid fa-check"
                  loading={loadingButton}
                  onClick={() => handleAccept()}
                  rounded
                />
              </div>
            )}
          {permissions &&
            permissions.includes("69") && ( //Recusar Cessão
              <div className="col-md-6 text-center">
                <Button
                  label="Recusar"
                  className="bg-danger w-50"
                  icon="fa-solid fa-ban"
                  loading={loadingButton}
                  onClick={() => handleDeny()}
                  style={{ border: "none" }}
                  rounded
                />
              </div>
            )}
        </div>
      </Modal>
    </>
  );
};

export default Assignment;
